import type { DesignItem } from '@core/types';
import type { ViewName } from '../stores/designStore';

export type DesignHistoryItems = Record<ViewName, DesignItem[]>;

export function cloneDesignHistoryItems(items: DesignHistoryItems): DesignHistoryItems {
  return JSON.parse(JSON.stringify(items)) as DesignHistoryItems;
}

export function designHistoryKey(items: DesignHistoryItems): string {
  return JSON.stringify(items);
}

export function retainValidHistorySelection(selectedIds: string[], items: DesignItem[]): string[] {
  const available = new Set(items.map((item) => item.id));
  return selectedIds.filter((id) => available.has(id));
}
